module.exports = __webpack_public_path__ + "img/Group 27962@2x.d54c3eca.png";